import { setRoute } from '../../routes/actions/set';
import { clearAdditional } from '../../routes/actions/clear-additional';

export function request() {
    return {
        type: 'USER_LOGOUT_REQUEST'
    };
}

export function finish() {
    return (dispatch) => {
        dispatch({
            type: 'USER_LOGOUT_FINISH'
        });

        dispatch(clearAdditional());
        dispatch(setRoute('global:login'));
    };
}
